<template>
    <back-to-home />
    <page-title :title="t('profile.profilePageTitle')" />
    <profile />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { Profile } from '@/features/Profile';
import { BackToHome, PageTitle } from '@/features/common/components/page';

const { t } = useI18n();
</script>

<style lang="scss">
.footer-text {
    text-align: center;
}
</style>
